export class RelevantLabDocument {
    document_name?: string;
    document_attached?: string;
    document_type?: string;
    document_uploaded? = false;
}